import React, { Component } from 'react';
import './CommentBlock.css';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import DropModal from 'components/shared/DropModal/DropModal';
import moment from 'moment';
import classnames from 'classnames';
import { IconLoader } from 'common/IconLoader';

class CommentBlock extends Component {
  state = {
    textHeight: 0,
    maximizeText: false
  };

  componentDidMount() {
    const textHeight = this.spanRef.clientHeight;
    this.setState({ textHeight });
  }

  componentDidUpdate(prevProps, prevState) {
    const textHeight = this.spanRef.clientHeight;
    if (this.state.textHeight !== textHeight) this.setState({ textHeight });
  }

  render() {
    let isOverflowing = this.state.textHeight >= this.props.maxTextHeight;

    let dotsButton = (
      <div className={'editDots'}>
        <SvgAF img={IconLoader.icon_device_more} hover={IconLoader.icon_device_more_hover} />
      </div>
    );

    return (
      <div className="commentBlockContainer">
        <div className="commentHeader">
          <div className="commentBlockHeaderLeft">
            <div className="userLabel">{this.props.commentData.user}</div>
          </div>
          <div className="commentBlockHeaderRight">
            <div className="timeLabel">
              {moment(this.props.commentData.recordedTime).format('MMM DD') +
                ' at ' +
                moment(this.props.commentData.recordedTime).format('H:mm a')}
            </div>
            <DropModal title={dotsButton} name={'comment' + this.props.commentData.comment_id}>
              <button
                onClick={() => {
                  this.props.deleteComment(this.props.commentData.comment_id);
                }}
              >
                Delete
              </button>
            </DropModal>
          </div>
        </div>
        <div
          className={classnames(
            'commentContent',
            { maxLimitedPadding: this.state.maximizeText === false },
            { maxUnlimitedPadding: this.state.maximizeText === true || !isOverflowing }
          )}
        >
          <div
            ref={(spanRef) => {
              this.spanRef = spanRef;
            }}
            className="textContainer"
          >
            <span
              className={classnames(
                { maxLimited: this.state.maximizeText === false },
                { maxUnlimited: this.state.maximizeText === true }
              )}
            >
              {this.props.commentData.text}
            </span>
          </div>
        </div>
        {isOverflowing && this.state.maximizeText === false && (
          <div className="commentFooter">
            <IconAndText
              img={IconLoader.icon_more_note}
              hoverImg={IconLoader.icon_more_note_hover}
              text={'MORE'}
              onClick={() => this.setState({ maximizeText: true })}
              reverse
            />
          </div>
        )}
      </div>
    );
  }
}

export default CommentBlock;
